export default class NothingToSnap extends Error {}
